// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__2czqS","dragIcon":"Choice_dragIcon__Xs7k7","left":"Choice_left__1eKnh","input":"Choice_input__eU5D8"};